import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperVagas = () => {
  const section = document.querySelector("#vagas-nucleon");
  if (!section) return;

  const swiperEl = section.querySelector(".mySwiperVagas .swiper-wrapper");
  const numeracaoContainer = section.querySelector('.swiper-numeracao');
  const btnNext = section.querySelector(".swiper-button-next-vagas");
  const btnPrev = section.querySelector(".swiper-button-prev-vagas");

  if (!swiperEl || !numeracaoContainer || !btnNext || !btnPrev) return;

  const slidesPorGrupo = 4;
  let swiper = null;
  let grupoAtual = 0;

  const allSlides = Array.from(swiperEl.children).map(slide => slide.cloneNode(true));

  function criarSwiperComSlides(slides) {
    swiperEl.innerHTML = '';
    slides.forEach(slide => swiperEl.appendChild(slide));

    if (swiper) swiper.destroy(true, true);

    const isMobile = window.innerWidth < 768;

    swiper = new Swiper(swiperEl.parentElement, {
      slidesPerView: isMobile ? 1 : slidesPorGrupo,
      slidesPerGroup: isMobile ? 1 : slidesPorGrupo,
      spaceBetween: 16,
      loop: false,
      allowTouchMove: true,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      on: {
        init() {
          atualizarUI(slides.length);
        },
        slideChange() {
          grupoAtual = Math.floor(swiper.activeIndex / (isMobile ? 1 : slidesPorGrupo));
          atualizarUI(slides.length);
        }
      }
    });

    grupoAtual = 0;
  }

  function atualizarUI(totalSlides) {
    const isMobile = window.innerWidth < 768;
    const totalGrupos = Math.ceil(totalSlides / slidesPorGrupo);
    const total = isMobile ? totalSlides : totalGrupos;
    const indexAtual = isMobile ? swiper?.activeIndex + 1 : grupoAtual + 1;

    if (total === 0) {
      numeracaoContainer.innerHTML =
        `<span class="text-black font-bold">00</span><span class="text-neutral-10/40">/</span><span class="text-neutral-10/40">00</span>`;
    } else {
      numeracaoContainer.innerHTML =
        `<span class="text-black font-bold">${String(indexAtual).padStart(2, '0')}</span><span class="text-neutral-10/40">/</span><span class="text-neutral-10/40">${String(total).padStart(2, '0')}</span>`;
    }

    if (total === 0) {
      swiperEl.parentElement.style.display = 'none';
      numeracaoContainer.textContent = 'Sem vagas para essa cidade.';
    } else {
      swiperEl.parentElement.style.display = '';
    }
  }

  function filtrarVagasPorCidade(cidade) {
    let slidesFiltrados;

    if (cidade === 'Todos') {
      slidesFiltrados = allSlides.map(slide => slide.cloneNode(true));
    } else {
      slidesFiltrados = allSlides
        .filter(slide => slide.dataset.cidade === cidade)
        .map(slide => slide.cloneNode(true));
    }

    criarSwiperComSlides(slidesFiltrados);
  }

  // Botões (não links): o filtro é só visual, sem gerar URLs ?cidade=
  // rastreáveis pelos buscadores.
  const linksCidades = document.querySelectorAll('#swiper-cidades button, #swiper-cidades a');
  linksCidades.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      const cidade = (link.dataset.cidade || link.textContent).trim();

      filtrarVagasPorCidade(cidade);

      linksCidades.forEach(l => {
        l.classList.remove('bg-primary-pure', 'text-black');
        l.classList.add('text-neutral-60');
      });

      link.classList.add('bg-primary-pure', 'text-black');
      link.classList.remove('text-neutral-60');
    });
  });

  // Corrige o estilo das setas desabilitadas
  const estilo = document.createElement("style");
  estilo.textContent = `
    .swiper-button-disabled {
      opacity: 1 !important;
      pointer-events: auto !important;
      cursor: pointer !important;
    }
  `;
  document.head.appendChild(estilo);

  window.addEventListener('resize', () => {
    if (!swiper) return;
    atualizarUI(swiper.slides.length);
  });

  filtrarVagasPorCidade('Todos');
};

export default initializeSwiperVagas;
